import React, { useState, useEffect } from 'react';
import { getServices } from '../services/api';
import ServiceCard from '../components/ServiceCard';
import './Services.css';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const response = await getServices();
        // Ensure we're setting an array even if the response is not an array
        setServices(Array.isArray(response.data) ? response.data : []);
        setError(null);
      } catch (error) {
        console.error('Error fetching services:', error);
        setError('Failed to load services. Please try again later.');
        setServices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading services...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>Oops! Something went wrong</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()} className="btn btn-primary">
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="services-page">
      <div className="page-header">
        <h1>My Services</h1>
        <p>Comprehensive digital solutions tailored to your needs</p>
      </div>

      <div className="services-container">
        {services.length > 0 ? (
          <div className="services-grid">
            {services.map((service, index) => (
              <ServiceCard key={service.id || index} service={service} delay={index * 100} />
            ))}
          </div>
        ) : (
          <div className="no-services">
            <p>No services available at the moment.</p>
          </div>
        )}
      </div>

      <div className="services-cta">
        <div className="cta-content">
          <h2>Ready to start your project?</h2>
          <p>Let's discuss how I can help bring your ideas to life</p>
          <a href="/contact" className="btn btn-primary">Get in Touch</a>
        </div>
      </div>
    </div>
  );
};

export default Services;